import { Component, OnInit } from '@angular/core';

import {
  MembershipGiftingConfig
} from '../../../../../models/membership';
import { MembershipService } from '../../../../../services/membership/membership.service';
import { EntryPassGiftingConfig } from '../../../../../models/entry-pass';
import { EntryPassService } from '../../../../../services/entry-pass/entry-pass.service';
import { VoucherPackService } from '../../../../../services/voucher-pack/voucher-pack.service';
import { VoucherPackGiftingConfig } from '../../../../../models/voucher-pack';
import { OrganizationConfig } from '../../../../../models/organization-config';
import { OrganizationConfigService } from '../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-gifting-config',
  templateUrl: './gifting-config.component.html',
  styleUrls: ['./gifting-config.component.css']
})
export class GiftingConfigComponent implements OnInit {
  public membershipGiftingConfigList: MembershipGiftingConfig[] = null;
  public entryPassGiftingConfigList: EntryPassGiftingConfig[] = null;
  public voucherPackGiftingConfigList: VoucherPackGiftingConfig[] = null;

  public orgConfig: OrganizationConfig;

  public loadingMembershipGiftingConfigs = true;
  public loadingEntryPassGiftingConfigs = true;
  public loadingVoucherPackGiftingConfigs = true;

  public serverError: number = null;

  // Make browser history available to the template.
  public history: History;

  constructor(
    private membershipService: MembershipService,
    private entryPassService: EntryPassService,
    private voucherPackService: VoucherPackService,
    private orgConfigService: OrganizationConfigService,
  ) {}

  ngOnInit() {
    // Make browser history available to the template.
    this.history = history;

    this.loadMembershipGiftingConfigs();
    this.loadEntryPassGiftingConfigs();
    this.loadVoucherPackGiftingConfigs();

    this.orgConfig = this.orgConfigService.getOrganizationConfig();
    if (this.orgConfig === null) {
      this.orgConfigService.loadOrganizationConfig().then(() => {
        this.orgConfig = this.orgConfigService.getOrganizationConfig();
      });
    }
  }

  public membershipGiftingConfigResultsPresent() {
    return (
      (this.membershipGiftingConfigList !== null) &&
      (this.membershipGiftingConfigList.length >  0)
    );
  }

  public entryPassGiftingConfigResultsPresent() {
    return (
      (this.entryPassGiftingConfigList !== null) &&
      (this.entryPassGiftingConfigList.length >  0)
    );
  }

  public voucherPackGiftingConfigResultsPresent() {
    return (
      (this.voucherPackGiftingConfigList !== null) &&
      (this.voucherPackGiftingConfigList.length >  0)
    );
  }

  private loadMembershipGiftingConfigs() {
    this.loadingMembershipGiftingConfigs = true;

    this.membershipService
      .getMembershipGiftingConfigs()
      .then(response => {
        this.membershipGiftingConfigList = response;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => {
        this.loadingMembershipGiftingConfigs = false;
      });
  }

  private loadEntryPassGiftingConfigs() {
    this.loadingEntryPassGiftingConfigs = true;

    this.entryPassService
      .getEntryPassGiftingConfigs()
      .then(response => {
        this.entryPassGiftingConfigList = response;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => {
        this.loadingEntryPassGiftingConfigs = false;
      });
  }

  private loadVoucherPackGiftingConfigs() {
    this.loadingVoucherPackGiftingConfigs = true;

    this.voucherPackService
      .getVoucherPackGiftingConfigs()
      .then(response => {
        this.voucherPackGiftingConfigList = response;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => {
        this.loadingVoucherPackGiftingConfigs = false;
      });
  }
}
